var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollapseLeftbarHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 159,
    viewBox: "0 0 26 159",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0L26 14.336V142.709L0 159V0Z",
    fill: "#2C2F64"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapseLeftbarHome);
export default __webpack_public_path__ + "static/media/CollapseLeftbar-home.94eb323e29cf1faa7d52cd6b2cc8ed94.svg";
export { ForwardRef as ReactComponent };